var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 32,
    viewBox: "0 0 36 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 32,
    rx: 6,
    fill: "#E6ECF0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1058_225)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3068 14.4227V10.1665H22.2183V14.4227H21.6911C21.2309 14.4227 20.8578 14.7958 20.8578 15.256V16.8998C20.8578 17.36 21.2309 17.7331 21.6911 17.7331H22.2183V21.5951H23.3068V17.7331H23.834C24.2942 17.7331 24.6673 17.36 24.6673 16.8998V15.256C24.6673 14.7958 24.2942 14.4227 23.834 14.4227H23.3068ZM18.5449 10.1665H17.4564V11.9004H16.9292C16.469 11.9004 16.0959 12.2735 16.0959 12.7337V14.3774C16.0959 14.8377 16.469 15.2108 16.9292 15.2108H17.4564V21.5951H18.5449V15.2108H19.0721C19.5323 15.2108 19.9054 14.8377 19.9054 14.3774V12.7337C19.9054 12.2735 19.5323 11.9004 19.0721 11.9004H18.5449V10.1665ZM13.783 16.5383V10.1665H12.6945V16.5383H12.1673C11.7071 16.5383 11.334 16.9114 11.334 17.3716V19.0089C11.334 19.4691 11.7071 19.8422 12.1673 19.8422H12.6945V21.5902L13.783 21.5951V19.8422H14.3102C14.7704 19.8422 15.1435 19.4691 15.1435 19.0089V17.3716C15.1435 16.9114 14.7704 16.5383 14.3102 16.5383H13.783Z",
    fill: "#2D3540"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1058_225"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(8 6)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filterIcon.2b32175d35ad3132e45b7cffeaded009.svg";
export { ForwardRef as ReactComponent };